// Single source of truth for the included-credit counts the UI quotes per plan.
// Mirrors the backend map in StripePlanService (TRIAL/STARTER = 50, EXPLORER = 75,
// PRO = 100). Enterprise has no published number. Update here only.
export const PLAN_NAMES = {
  TRIAL: 'Trial',
  STARTER: 'Starter',
  EXPLORER: 'Explorer',
  PRO: 'Pro'
}

export const PLAN_INCLUDED_CREDITS = {
  [PLAN_NAMES.TRIAL]: 50,
  [PLAN_NAMES.STARTER]: 50,
  [PLAN_NAMES.EXPLORER]: 75,
  [PLAN_NAMES.PRO]: 100
}

// Credits a brand-new account starts with (trial / free Starter tier).
export const TRIAL_INCLUDED_CREDITS = PLAN_INCLUDED_CREDITS[PLAN_NAMES.TRIAL]

// Plan names come from the API (subscriptionDetails.currentPlan) so match loosely.
export const getIncludedCredits = planName => {
  if (!planName) return undefined
  const key = Object.keys(PLAN_INCLUDED_CREDITS)
    .find(name => name.toLowerCase() === String(planName).trim().toLowerCase())
  return key ? PLAN_INCLUDED_CREDITS[key] : undefined
}
